<script setup>
import {formatMoney} from "@/utilities";
import {computed} from "vue";

const props = defineProps({
    price: Number,
    discountPrice: Number,
    hideDiscount: Boolean,
});

const discounted = computed(() => {
    return props.discountPrice !== props.price;
});
</script>

<template>
    <div class="flex items-center gap-2 text-xl md:text-2xl">
        <span class="font-jum-black">
            <span class="font-myraid-pro font-black">€</span>
            <template v-if="discounted">{{ formatMoney(discountPrice) }}</template>
            <template v-else>{{ formatMoney(price) }}</template>
        </span>
        <div
            v-if="discounted && !hideDiscount"
            class="text-xs font-bold text-grey-100 line-through"
        >
            <span class="font-myraid-pro font-black">€</span>
            {{ formatMoney(price) }}
        </div>
    </div>
</template>

